import { useState, useContext, Fragment } from "react";

import classes from "./CartDrinkBar.module.css";

import CartContext from "../../../store/cart-context";

// component for each drink in cart
const CartDrinkBar = (props) => {
  const cartCtx = useContext(CartContext);

  const [showOptions, toggleShowOptions] = useState(false);

  const drink = props.drink;

  // show options to either delete drink from cart or edit amount
  const showOptionsHandler = (event) => {
    event.stopPropagation();
    toggleShowOptions(!showOptions);
  };

  // remove one of drink from cart
  const deleteDrinkHandler = (event) => {
    event.stopPropagation();
    cartCtx.removeItem(drink.id);
    cartCtx.saveCart()
    event.stopPropagation()
  };

  // add one of drink to cart
  const addDrinkHandler = (event) => {
    event.stopPropagation();
    cartCtx.addItem(drink);
    cartCtx.saveCart()
    event.stopPropagation()
  };

  // delete all of drink from cart
  const clearItemHandler = (event) => {
    event.stopPropagation();
    cartCtx.clearItem(drink.id);
    cartCtx.saveCart()
  };

  return (
    <div className={classes.cartCard} onClick={showOptionsHandler}>
      {!showOptions ? (
        <Fragment>
          <div className={classes.imageBlocker}>
            <img className={classes.drinkImage} src={drink.image} alt="new" />
          </div>
          <div className={classes.drinkName}>
            {drink.title}
          </div>
          <div className={classes.drinkAmount}>{drink.amount}</div>
        </Fragment>
      ) : (
        <Fragment>
          <div className={classes.removeButton} onClick={deleteDrinkHandler}>
            -
          </div>
    
          <div className={classes.addButton} onClick={addDrinkHandler}>
            +
          </div>
          <div className={classes.clearButton} onClick={clearItemHandler}>
            clear
          </div>
          <div
            className={classes.toggleViewButton}
            onClick={showOptionsHandler}
          >
            &#62;&#62;
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default CartDrinkBar;
